/**
 * @file Pool d'objets generique (acquire/release) pour eviter les allocations par tic (projectiles, entites).
 */

export class Pool<T> {
  private readonly free: T[] = [];
  private created = 0;

  constructor(
    private readonly factory: () => T,
    private readonly reset: (item: T) => void,
    prewarm = 0,
    private readonly maxSize = Number.POSITIVE_INFINITY,
  ) {
    for (let i = 0; i < prewarm; i++) this.free.push(this.make());
  }

  private make(): T {
    this.created++;
    return this.factory();
  }

  acquire(): T {
    return this.free.pop() ?? this.make();
  }

  release(item: T): void {
    this.reset(item);
    if (this.free.length < this.maxSize) this.free.push(item);
  }

  get freeCount(): number {
    return this.free.length;
  }

  get totalCreated(): number {
    return this.created;
  }
}
